import React, { Component } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles, Button } from '@material-ui/core';
import { Form } from 'react-final-form';

import styles from './styles';
import fields from './fields';

import { CommonPanel } from 'components';
import { FormField } from 'components';
import PermissionCategories from 'views/PermissionCategories';
import { getOne, updateOne, createOne, resetForm } from './_actions';

// Inject reducers
import { store } from 'utils/store';
import { permissionCategoriesForm } from './_reducers';
store.injectReducer('permissionCategoriesForm', permissionCategoriesForm);


class PermissionCategoriesForm extends Component {

  componentDidMount() {
    const { match, dispatch } = this.props;

    if (match.params.id) {
      dispatch(getOne(match.params.id));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(resetForm());
  }


  validate(values) {
    const { t } = this.props; 
    let errors = {};

    if (!values.title) {
      errors.title = t('Privaloma');
    }

    return errors;
  }

  onSubmit(values) {
    const { dispatch } = this.props;

    if (values._id) {
      // Update
      dispatch(updateOne(values));
    } else {
      // Create
      dispatch(createOne(values));
    }
  }

  submitForm() {
    document
      .getElementById('permissionCategoriesForm')
      .dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }


  render() {
    const { classes, record, t } = this.props;
    const title = _.get(record, 'title', t('Nauja kategorija'));

    return (
      <PermissionCategories
        title={title}
        breadcrumbs={[
          { title: t('Administravimas') },
          { title: t('Prieigos teisių kategorijos'), to: '/permission-categories' },
          { title }
        ]}
      >
        
        <CommonPanel>
          <Form
            initialValues={record}
            onSubmit={this.onSubmit.bind(this)}
            validate={this.validate.bind(this)}
            render={({ handleSubmit }) => (
              <form
                id="permissionCategoriesForm"
                className={classes.form}
                onSubmit={handleSubmit}
              >
                
                {_.map(fields, field => <FormField key={field.name} {...field}/>)}
                
              </form>
            )}
          />

          <Button
            color="primary"
            variant="contained"
            onClick={event => this.submitForm(event)}
          >
            {t('Išsaugoti')}
          </Button>

        </CommonPanel>

      </PermissionCategories>
    );
  }
}

const mapStateToProps = ({ permissionCategoriesForm, dispatch }) => {
  return { 
    ...permissionCategoriesForm,
    dispatch,
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation(),
)(PermissionCategoriesForm);